export const articles = [
  {
    "name": "Biden’s executive action to extend eviction moratorium is a ‘Band-Aid’ on the rental crisis",
    "pdf_path": "/frontpage/Biden’s executive action to extend eviction moratorium is a ‘Band-Aid’ on the rental crisis.pdf",
    "preview": "/frontpage/Biden’s executive action to extend eviction moratorium is a ‘Band-Aid’ on the rental crisis.cover.png",
    "index": Math.random().toString(36).substring(2, 15)
  },
  {
    "name": "Budget breakdown_ How three millennials spend and save their $50,000 salary - Cashay",
    "pdf_path": "/frontpage/Budget breakdown_ How three millennials spend and save their $50,000 salary - Cashay.pdf",
    "preview": "/frontpage/Budget breakdown_ How three millennials spend and save their $50,000 salary - Cashay.cover.png",
    "index": Math.random().toString(36).substring(2, 15)
  },
  {
    "name": "Early retirement_ What happens when the unexpected occurs (1)",
    "pdf_path": "/frontpage/Early retirement_ What happens when the unexpected occurs (1).pdf",
    "preview": "/frontpage/Early retirement_ What happens when the unexpected occurs (1).cover.png",
    "index": Math.random().toString(36).substring(2, 15)
  },
  {
    "name": "Gone in 90 minutes Rental assistance is quickly running out for struggling renters",
    "pdf_path": "/frontpage/Gone in 90 minutes Rental assistance is quickly running out for struggling renters.pdf",
      "preview": "/frontpage/Gone in 90 minutes Rental assistance is quickly running out for struggling renters.cover.png",
    "index": Math.random().toString(36).substring(2, 15)

  },
  {
    "name": "'In fear of my life' Loved ones send money to help protect inmates during pandemic",
    "pdf_path": "/frontpage/'In fear of my life' Loved ones send money to help protect inmates during pandemic.pdf",
    "preview": "/frontpage/'In fear of my life' Loved ones send money to help protect inmates during pandemic.cover.png",
    "index": Math.random().toString(36).substring(2, 15)
  },
  {
    name: "Best retirement plans of 2024",
    index: "1",
    pdf_path: "/articles/1.pdf",
    preview: "/previews/1.cover.png",
  },
  {
    name: "How to retire early - 5 steps to early retirement",
    index: "2",
    pdf_path: "/articles/2.pdf",
    preview: "/previews/2.cover.png",
  },
  {
    name: "Best cash advance apps for gig workers",
    index: "3",
    pdf_path: "/articles/3.pdf",
    preview: "/previews/3.cover.png",
  },
  {
    name: "Beagle review 2024",
    index: "4",
    pdf_path: "/articles/4.pdf",
    preview: "/previews/4.cover.png",
  },
  {
    name: "How to get a $400,000 business loan",
    index: "5",
    pdf_path: "/articles/5.pdf",
    preview: "/previews/5.cover.png",
  },
  {
    name: "How to get a $200,000 business loan",
    index: "6",
    pdf_path: "/articles/6.pdf",
    preview: "/previews/6.cover.png",
  },
  {
    name: "How to get a $150,000 business loan",
    index: "7",
    pdf_path: "/articles/7.pdf",
    preview: "/previews/7.cover.png",
  },
  {
    name: "How to get a $60,000 business loan",
    index: "8",
    pdf_path: "/articles/8.pdf",
    preview: "/previews/8.cover.png",
  },
  {
    name: "What is a credit builder loan",
    index: "9",
    pdf_path: "/articles/9.pdf",
    preview: "/previews/9.cover.png",
  },
  {
    name: "What credit score is needed for a personal loan",
    index: "10",
    pdf_path: "/articles/10.pdf",
    preview: "/previews/10.cover.png",
  },
  {
    name: "How long does it take to build credit",
    index: "11",
    pdf_path: "/articles/11.pdf",
    preview: "/previews/11.cover.png",
  },
  {
    name: "What's a bad credit score",
    index: "12",
    pdf_path: "/articles/12.pdf",
    preview: "/previews/12.cover.png",
  },
  {
    name: "What is a good credit score",
    index: "13",
    pdf_path: "/articles/13.pdf",
    preview: "/previews/13.cover.png",
  },
  {
    name: "5 small business stories that'll make you rethink taking out a loan",
    index: "14",
    pdf_path: "/articles/14.pdf",
    preview: "/previews/14.cover.png",
  },
  {
    name: "5 cash advance apps that work with albert",
    index: "15",
    pdf_path: "/articles/15.pdf",
    preview: "/previews/15.cover.png",
  },
  {
    name: "Loans like viva finance",
    index: "16",
    pdf_path: "/articles/16.pdf",
    preview: "/previews/16.cover.png",
  },
  {
    name: "How much money should i have saved by 30",
    index: "17",
    pdf_path: "/articles/17.pdf",
    preview: "/previews/17.cover.png",
  },
  {
    name: "4 cash advance apps that work with netspend",
    index: "18",
    pdf_path: "/articles/18.pdf",
    preview: "/previews/18.cover.png",
  },
  {
    name: "Fundbox vs. american epress business line of credit: which is better?",
    index: "19",
    pdf_path: "/articles/19.pdf",
    preview: "/previews/19.cover.png",
  },
  {
    name: "OnDeck vs. american epress business line of credit: which is better?",
    index: "20",
    pdf_path: "/articles/20.pdf",
    preview: "/previews/20.cover.png",
  },
  {
    name: "Bluevine vs. fundbox: which is better?",
    index: "21",
    pdf_path: "/articles/21.pdf",
    preview: "/previews/21.cover.png",
  },
  {
    name: "5 cash advance apps that work with venmo",
    index: "22",
    pdf_path: "/articles/22.pdf",
    preview: "/previews/22.cover.png",
  },
  {
    name: "7 cash advance apps that work with ADP",
    index: "23",
    pdf_path: "/articles/23.pdf",
    preview: "/previews/23.cover.png",
  },
  {
    name: "5 cash advance apps that work with paypal",
    index: "24",
    pdf_path: "/articles/24.pdf",
    preview: "/previews/24.cover.png",
  },
  {
    name: "fundera vs. lendio: which is better?",
    index: "25",
    pdf_path: "/articles/25.pdf",
    preview: "/previews/25.cover.png",
  },
  {
    name: "upgrade vs. upstart: which is better?",
    index: "26",
    pdf_path: "/articles/26.pdf",
    preview: "/previews/26.cover.png",
  },
  {
    name: "lightstream vs. sofi: which is better?",
    index: "27",
    pdf_path: "/articles/27.pdf",
    preview: "/previews/27.cover.png",
  },
  {
    name: "Best egg vs. upstart: which is better?",
    index: "28",
    pdf_path: "/articles/28.pdf",
    preview: "/previews/28.cover.png",
  },
  {
    name: "upstart vs. sofi: which is better?",
    index: "29",
    pdf_path: "/articles/29.pdf",
    preview: "/previews/29.cover.png",
  },
  {
    name: "sofi vs. lendingclub: which is better?",
    index: "30",
    pdf_path: "/articles/30.pdf",
    preview: "/previews/30.cover.png",
  },
  {
    name: "5 loans like fig loans",
    index: "31",
    pdf_path: "/articles/31.pdf",
    preview: "/previews/31.cover.png",
  },
  {
    name: "5 best stock picking services of 2024",
    index: "32",
    pdf_path: "/articles/32.pdf",
    preview: "/previews/32.cover.png",
  },
  {
    name: "how to buy vinfast stock",
    index: "33",
    pdf_path: "/articles/33.pdf",
    preview: "/previews/33.cover.png",
  },
  {
    name: "how to buy discord stock when it goes public",
    index: "34",
    pdf_path: "/articles/34.pdf",
    preview: "/previews/34.cover.png",
  },
  {
    name: "how to read stock charts: a beginner's guide",
    index: "35",
    pdf_path: "/articles/35.pdf",
    preview: "/previews/35.cover.png",
  },
  {
    name: "how to buy databricks stock when it goes public",
    index: "36",
    pdf_path: "/articles/36.pdf",
    preview: "/previews/36.cover.png",
  },
  {
    name: "how to buy triller (ILLR) stock when it goes public",
    index: "37",
    pdf_path: "/articles/37.pdf",
    preview: "/previews/37.cover.png",
  },
  {
    name: "How to buy stripe stock when it goes public",
    index: "38",
    pdf_path: "/articles/38.pdf",
    preview: "/previews/38.cover.png",
  },
  {
    name: "How to buy Airbnb stock",
    index: "39",
    pdf_path: "/articles/39.pdf",
    preview: "/previews/39.cover.png",
  },
  {
    name: "what is after-hours trading and how does it work",
    index: "40",
    pdf_path: "/articles/40.pdf",
    preview: "/previews/40.cover.png",
  },
  {
    name: "what is day trading and how does it work",
    index: "41",
    pdf_path: "/articles/41.pdf",
    preview: "/previews/41.cover.png",
  },
  {
    name: "how to buy berkshire hathaway stock",
    index: "42",
    pdf_path: "/articles/42.pdf",
    preview: "/previews/42.cover.png",
  },
  {
    name: "how to buy walmart stock",
    index: "43",
    pdf_path: "/articles/43.pdf",
    preview: "/previews/43.cover.png",
  },
  {
    name: "how to buy shopify stock",
    index: "44",
    pdf_path: "/articles/44.pdf",
    preview: "/previews/44.cover.png",
  },
  {
    name: "how to buy target corporation stock",
    index: "45",
    pdf_path: "/articles/45.pdf",
    preview: "/previews/45.cover.png",
  },
  {
    name: "how to buy nike stock",
    index: "46",
    pdf_path: "/articles/46.pdf",
    preview: "/previews/46.cover.png",
  },
  {
    name: "how to buy intel corporation stock",
    index: "47",
    pdf_path: "/articles/47.pdf",
    preview: "/previews/47.cover.png",
  },
  {
    name: "how to buy ford motor company stock",
    index: "48",
    pdf_path: "/articles/48.pdf",
    preview: "/previews/48.cover.png",
  },
  {
    name: "how to buy disney stock",
    index: "49",
    pdf_path: "/articles/49.pdf",
    preview: "/previews/49.cover.png",
  },
  {
    name: "how to buy zoom video communications stock",
    index: "50",
    pdf_path: "/articles/50.pdf",
    preview: "/previews/50.cover.png",
  },
  {
    name: "how to buy alibaba holding stock",
    index: "51",
    pdf_path: "/articles/51.pdf",
    preview: "/previews/51.cover.png",
  },
  {
    name: "flight school loans and how to pay for flight school",
    index: "52",
    pdf_path: "/articles/52.pdf",
    preview: "/previews/52.cover.png",
  },
  {
    name: "optima tax relief review",
    index: "53",
    pdf_path: "/articles/53.pdf",
    preview: "/previews/53.cover.png",
  },
  {
    name: "onDeck vs. prosper: which is better?",
    index: "54",
    pdf_path: "/articles/54.pdf",
    preview: "/previews/54.cover.png",
  },
  {
    name: "loanbuilder vs. onDeck: which is better?",
    index: "55",
    pdf_path: "/articles/55.pdf",
    preview: "/previews/55.cover.png",
  },
  {
    name: "Millennial Inheritances May Look Different Than Expected",
    index: "56",
    pdf_path: "/articles/56.pdf",
    preview: "/previews/56.cover.png",
  },
  {
    name: "Financial Stress Survey: 65% of Americans Say Finances Are Their Biggest Source of Stress",
    index: "57",
    pdf_path: "/articles/57.pdf",
    preview: "/previews/57.cover.png",
  },
  {
    name: "Layoff Anxiety Survey: 7 in 10 Workers Are Bracing for Job Cuts",
    index: "58",
    pdf_path: "/articles/58.pdf",
    preview: "/previews/58.cover.png",
  },
  {
    name: "Missed or late student loan payments can once again be reported to credit bureaus: Here's what to know",
    index: "59",
    pdf_path: "/articles/59.pdf",
    preview: "/previews/59.cover.png",
  },
  {
    name: "College Cost Calculator: Estimate how much college may cost you",
    index: "60",
    pdf_path: "/articles/60.pdf",
    preview: "/previews/60.cover.png",
  },
  {
    name: "Meet three Gen-Z entrepreneurs who turned college side hustles into full-fledged businesses",
    index: "61",
    pdf_path: "/articles/61.pdf",
    preview: "/previews/61.cover.png",
  },
  {
    name: "What's Chase Spending Planner? A breakdown on what the tool is and how to use it",
    index: "62",
    pdf_path: "/articles/62.pdf",
    preview: "/previews/62.cover.png",
  },
  {
    name: "Chase Debt Management Calculator: Get help picking your payoff strategy",
    index: "63",
    pdf_path: "/articles/63.pdf",
    preview: "/previews/63.cover.png",
  },
  {
    name: "What's Chase Autosave? A beginner's guide",
    index: "64",
    pdf_path: "/articles/64.pdf",
    preview: "/previews/64.cover.png",
  },
  {
    name: "Dhara Singh",
    index: "65",
    pdf_path: "/articles/65.pdf",
    preview: "/previews/65.cover.png",
  },
  {
    name: "Millennial Inheritances May Look Different Than Expected",
    index: "66",
    pdf_path: "/articles/66.pdf",
    preview: "/previews/66.cover.png",
  },
  {
    name: "10 steps to take if you want to buy a home in 2020 - Cashay",
    index: "67",
    pdf_path: "/articles/67.pdf",
    preview: "/previews/67.cover.png"
  },
  {
    name: "10 steps you should take if you want to buy a home in 2020",
    index: "68",
    pdf_path: "/articles/68.pdf",
    preview: "/previews/68.cover.png"
  },
  {
    name: "19-year-old solves tech gap for isolated coronavirus patients and their families",
    index: "69",
    pdf_path: "/articles/69.pdf",
    preview: "/previews/69.cover.png"
  },
  {
    name: "2 in 5 Americans under 60 believe Social Security is a Ponzi scheme, survey finds",
    index: "71",
    pdf_path: "/articles/71.pdf",
    preview: "/previews/71.cover.png"
  },
  {
    name: "30-year mortgage rates sink to another record low",
    index: "72",
    pdf_path: "/articles/72.pdf",
    preview: "/previews/72.cover.png"
  },
  {
    name: "3 in 5 older workers could retire in poverty due to pandemic",
    index: "73",
    pdf_path: "/articles/73.pdf",
    preview: "/previews/73.cover.png"
  },
  {
    name: "3 moves to make before July 15 to reduce your taxes - Cashay",
    index: "74",
    pdf_path: "/articles/74.pdf",
    preview: "/previews/74.cover.png"
  },
  {
    name: "4 Social Security tips to plan your retirement - Cashay",
    index: "75",
    pdf_path: "/articles/75.pdf",
    preview: "/previews/75.cover.png"
  },
  {
    name: "Alarming number_ Boomers struggle to save enough for retirement",
    index: "82",
    pdf_path: "/articles/82.pdf",
    preview: "/previews/82.cover.png"
  },
  {
    name: "All Markets Summit 2020_ How CEOs are addressing racial inequity - Cashay",
    index: "83",
    pdf_path: "/articles/83.pdf",
    preview: "/previews/83.cover.png"
  },
  {
    name: "Almost a third of Americans say they may never retire because of coronavirus hardships",
    index: "84",
    pdf_path: "/articles/84.pdf",
    preview: "/previews/84.cover.png"
  },
  {
    name: "Americans are increasingly going hungry as the pandemic rages and stimulus expires",
    index: "87",
    pdf_path: "/articles/87.pdf",
    preview: "/previews/87.cover.png"
  },
  {
    name: "Americans reveal 2020 financial resolutions in new survey",
    index: "88",
    pdf_path: "/articles/88.pdf",
    preview: "/previews/88.cover.png"
  },
  {
    name: "Americans struggle to delay mortgage payments as lenders cant handle 1,896 spike amid coronavirus",
    index: "89",
    pdf_path: "/articles/89.pdf",
    preview: "/previews/89.cover.png"
  },
  {
    name: "Americans struggle to tap home equity amid coronavirus pandemic",
    index: "90",
    pdf_path: "/articles/90.pdf",
    preview: "/previews/90.cover.png"
  },
  {
    name: "Americas financial struggles_ Heres what Joe Biden faces in January 2021",
    index: "91",
    pdf_path: "/articles/91.pdf",
    preview: "/previews/91.cover.png"
  },
  {
    name: "America's Social Security crisis is getting worse amid the coronavirus pandemic",
    index: "92",
    pdf_path: "/articles/92.pdf",
    preview: "/previews/92.cover.png"
  },
  {
    name: "Analysis finds a 'tipping point' for Americans struggling with household debt",
    index: "93",
    pdf_path: "/articles/93.pdf",
    preview: "/previews/93.cover.png"
  },
  {
    name: "Andrew Yang_ We should focus on relocating Americans impacted by climate change",
    index: "94",
    pdf_path: "/articles/94.pdf",
    preview: "/previews/94.cover.png"
  },
  {
    name: "April home sales hit the lowest level in almost a decade",
    index: "99",
    pdf_path: "/articles/99.pdf",
    preview: "/previews/99.cover.png"
  },
  {
    name: "Biden’s executive action to extend eviction moratorium is a ‘Band-Aid’ on the rental crisis",
    index: "101",
    pdf_path: "/articles/101.pdf",
    preview: "/previews/101.cover.png"
  },
  {
    name: "Biden's health care policy will change Medicare in 2 big ways",
    index: "102",
    pdf_path: "/articles/102.pdf",
    preview: "/previews/102.cover.png"
  },
  {
    name: "Biden signs executive memo to determine if Trump-era actions 'undermined fair housing policies and laws'",
    index: "103",
    pdf_path: "/articles/103.pdf",
    preview: "/previews/103.cover.png"
  },
  {
    name: "Biden's 'noble' plan for Social Security wouldn't solve all funding problems",
    index: "104",
    pdf_path: "/articles/104.pdf",
    preview: "/previews/104.cover.png"
  },
  {
    name: "Biden's plans will help those 'fearful of outliving their retirement savings'",
    index: "105",
    pdf_path: "/articles/105.pdf",
    preview: "/previews/105.cover.png"
  },
  {
    name: "Biden's Social Security and SSI plan would lift 1.4 million out of poverty, study finds",
    index: "106",
    pdf_path: "/articles/106.pdf",
    preview: "/previews/106.cover.png"
  },
  {
    name: "Black personal finance bloggers_ Here's what traditional money advice is missing on race - Cashay",
    index: "108",
    pdf_path: "/articles/108.pdf",
    preview: "/previews/108.cover.png"
  },
  {
    name: "Budget breakdown_ How three millennials spend and save their $50,000 salary - Cashay",
    index: "109",
    pdf_path: "/articles/109.pdf",
    preview: "/previews/109.cover.png"
  },
  {
    name: "Buffett 'I would disagree quite violently' with notion that passive investing is dead",
    index: "110",
    pdf_path: "/articles/110.pdf",
    preview: "/previews/110.cover.png"
  },
  {
    name: "BUILT BY GIRLS provides 5 tips to jumpstarting your career in 2020 - Cashay",
    index: "111",
    pdf_path: "/articles/111.pdf",
    preview: "/previews/111.cover.png"
  },
  {
    name: "BUILT BY GIRLS_ Top 5 money myths debunked for the class of 2020 - Cashay",
    index: "112",
    pdf_path: "/articles/112.pdf",
    preview: "/previews/112.cover.png"
  },
  {
    name: "CEO 'It's almost impossible' to find a pension plan that provides retirement income",
    index: "113",
    pdf_path: "/articles/113.pdf",
    preview: "/previews/113.cover.png"
  },
  {
    name: "CEO_ 'The definition of retirement in America has changed'",
    index: "114",
    pdf_path: "/articles/114.pdf",
    preview: "/previews/114.cover.png"
  },
  {
    name: "CEO_ You need to start saving for retirement 'right after high school' - Cashay",
    index: "115",
    pdf_path: "/articles/115.pdf",
    preview: "/previews/115.cover.png"
  },
  {
    name: "Chart_ Here's how much you need to save for a comfortable retirement",
    index: "117",
    pdf_path: "/articles/117.pdf",
    preview: "/previews/117.cover.png"
  },
  {
    name: "Coronavirus_ 5 money chores you can do during isolation - Cashay",
    index: "119",
    pdf_path: "/articles/119.pdf",
    preview: "/previews/119.cover.png"
  },
  {
    name: "Coronavirus cash crunch leading to more Americans withdrawing from 401k accounts",
    index: "120",
    pdf_path: "/articles/120.pdf",
    preview: "/previews/120.cover.png"
  },
  {
    name: "Coronavirus fears are creating a mortgage refinancing boom",
    index: "121",
    pdf_path: "/articles/121.pdf",
    preview: "/previews/121.cover.png"
  },
  {
    name: "Coronavirus_ Here_s what to do if you can't pay rent - Cashay",
    index: "122",
    pdf_path: "/articles/122.pdf",
    preview: "/previews/122.cover.png"
  },
  {
    name: "Coronavirus_ Here's what to do if you can't pay your mortgage - Cashay",
    index: "123",
    pdf_path: "/articles/123.pdf",
    preview: "/previews/123.cover.png"
  },
  {
    name: "Coronavirus_ Here_s what to do with your 401(k) if you lose your job",
    index: "124",
    pdf_path: "/articles/124.pdf",
    preview: "/previews/124.cover.png"
  },
  {
    name: "Coronavirus_ Homeowners can delay mortgage payments up to 12 months",
    index: "125",
    pdf_path: "/articles/125.pdf",
    preview: "/previews/125.cover.png"
  },
  {
    name: "Coronavirus is chasing away homebuyers",
    index: "126",
    pdf_path: "/articles/126.pdf",
    preview: "/previews/126.cover.png"
  },
  {
    name: "Coronavirus Millions are at risk of utilities being shut off as protections expire",
    index: "127",
    pdf_path: "/articles/127.pdf",
    preview: "/previews/127.cover.png"
  },
  {
    name: "Coronavirus put these Americans 'in purgatory' with unprecedented layoffs and furloughs",
    index: "128",
    pdf_path: "/articles/128.pdf",
    preview: "/previews/128.cover.png"
  },
  {
    name: "Coronavirus scams_ Experts provides tips to avoid falling victim amid lockdown",
    index: "129",
    pdf_path: "/articles/129.pdf",
    preview: "/previews/129.cover.png"
  },
  {
    name: "Coronavirus_ Should you move now that you can work from home_ - Cashay",
    index: "130",
    pdf_path: "/articles/130.pdf",
    preview: "/previews/130.cover.png"
  },
  {
    name: "Coronavirus Some U.S. companies eliminate employee 401(k) matches to cut costs",
    index: "131",
    pdf_path: "/articles/131.pdf",
    preview: "/previews/131.cover.png"
  },
  {
    name: "Coronavirus stimulus checks_ Advocates worry landlords are checking on renters' payments",
    index: "132",
    pdf_path: "/articles/132.pdf",
    preview: "/previews/132.cover.png"
  },
  {
    name: "Coronavirus stimulus checks_ Here's who is left out",
    index: "133",
    pdf_path: "/articles/133.pdf",
    preview: "/previews/133.cover.png"
  },
  {
    name: "Coronavirus stimulus checks_ What it means for your taxes - Cashay",
    index: "134",
    pdf_path: "/articles/134.pdf",
    preview: "/previews/134.cover.png"
  },
  {
    name: "Coronavirus stimulus checks_ Why many college students won't get one - Cashay",
    index: "135",
    pdf_path: "/articles/135.pdf",
    preview: "/previews/135.cover.png"
  },
  {
    name: "Coronavirus stimulus Millions of Americans face potential eviction as protections expire and talks stall",
    index: "136",
    pdf_path: "/articles/136.pdf",
    preview: "/previews/136.cover.png"
  },
  {
    name: "Coronavirus stimulus_ No action yet on Trump's executive order on evictions",
    index: "137",
    pdf_path: "/articles/137.pdf",
    preview: "/previews/137.cover.png"
  },
  {
    name: "Coronavirus_ The best ways to help others in need - Cashay",
    index: "138",
    pdf_path: "/articles/138.pdf",
    preview: "/previews/138.cover.png"
  },
  {
    name: "Coronavirus Trump administration attempts to prevent evictions using CDC quarantine authority",
    index: "139",
    pdf_path: "/articles/139.pdf",
    preview: "/previews/139.cover.png"
  },
  {
    name: "Coronavirus_ What banks, lenders, utilities and more are doing to help customers financially - Cashay",
    index: "140",
    pdf_path: "/articles/140.pdf",
    preview: "/previews/140.cover.png"
  },
  {
    name: "Coronavirus_ When you should withdraw from your 401(k)",
    index: "141",
    pdf_path: "/articles/141.pdf",
    preview: "/previews/141.cover.png"
  },
  {
    name: "Delinquent mortgages spike in April amid pandemic, study shows",
    index: "142",
    pdf_path: "/articles/142.pdf",
    preview: "/previews/142.cover.png"
  },
  {
    name: "Democrats_ Homeowners need to know about forbearance protections amid coronavirus",
    index: "143",
    pdf_path: "/articles/143.pdf",
    preview: "/previews/143.cover.png"
  },
  {
    name: "Democrats_ Senate must step up homeowner protections in next relief package",
    index: "144",
    pdf_path: "/articles/144.pdf",
    preview: "/previews/144.cover.png"
  },
  {
    name: "Early retiree Tanja Hester_ Americans need to 'get creative about ways to save money' during pandemic - Cashay",
    index: "145",
    pdf_path: "/articles/145.pdf",
    preview: "/previews/145.cover.png"
  },
  {
    name: "Early retirement_ What happens when the unexpected occurs_ - Cashay",
    index: "146",
    pdf_path: "/articles/146.pdf",
    preview: "/previews/146.cover.png"
  },
  {
    name: "Early retirement_ What happens when the unexpected occurs",
    index: "147",
    pdf_path: "/articles/147.pdf",
    preview: "/previews/147.cover.png"
  },
  {
    name: "Early-stage mortgage delinquencies hit 21-year high",
    index: "148",
    pdf_path: "/articles/148.pdf",
    preview: "/previews/148.cover.png"
  },
  {
    name: "Election 2020_ California strikes down rent control in ballot voting",
    index: "149",
    pdf_path: "/articles/149.pdf",
    preview: "/previews/149.cover.png"
  },
  {
    name: "Empty nesters welcoming children back during pandemic could hurt their finances",
    index: "150",
    pdf_path: "/articles/150.pdf",
    preview: "/previews/150.cover.png"
  },
  {
    name: "Expert_ Coronavirus starting to scare homebuyers and sellers away",
    index: "152",
    pdf_path: "/articles/152.pdf",
    preview: "/previews/152.cover.png"
  },
  {
    name: "Expert details the 'key to long-term retirement savings'",
    index: "153",
    pdf_path: "/articles/153.pdf",
    preview: "/previews/153.cover.png"
  },
  {
    name: "Expert_ It's better to tap into a low interest rate credit card than your 401K",
    index: "154",
    pdf_path: "/articles/154.pdf",
    preview: "/previews/154.cover.png"
  },
  {
    name: "Expert_ 'It's dangerous' when Americans use 401(k)s as emergency funds",
    index: "155",
    pdf_path: "/articles/155.pdf",
    preview: "/previews/155.cover.png"
  },
  {
    name: "Expert_ New retirees 'are going to have to adjust their expectations'",
    index: "156",
    pdf_path: "/articles/156.pdf",
    preview: "/previews/156.cover.png"
  },
  {
    name: "Expert Proposed rule on socially-conscious retirement investments 'just isn't logical'",
    index: "157",
    pdf_path: "/articles/157.pdf",
    preview: "/previews/157.cover.png"
  },
  {
    name: "Expert_ Retirement investors of all ages want 'to take risk off of the table'",
    index: "158",
    pdf_path: "/articles/158.pdf",
    preview: "/previews/158.cover.png"
  },
  {
    name: "Expert_ The SECURE Act's biggest effect wont be on retirees",
    index: "159",
    pdf_path: "/articles/159.pdf",
    preview: "/previews/159.cover.png"
  },
  {
    name: "Expiration of state eviction protections led to 434,000 extra COVID-19 cases, study finds",
    index: "160",
    pdf_path: "/articles/160.pdf",
    preview: "/previews/160.cover.png"
  },
  {
    name: "FAFSA_ 3 changes you should know about this college aid form - Cashay",
    index: "161",
    pdf_path: "/articles/161.pdf",
    preview: "/previews/161.cover.png"
  },
  {
    name: "Fannie Mae and Freddie Mac extend renter protections for 8.6 million households",
    index: "162",
    pdf_path: "/articles/162.pdf",
    preview: "/previews/162.cover.png"
  },
  {
    name: "Financial expert_ It's crazy that people don't have a budget",
    index: "163",
    pdf_path: "/articles/163.pdf",
    preview: "/previews/163.cover.png"
  },
  {
    name: "Foreclosure and eviction moratorium is extended through the end of the year",
    index: "164",
    pdf_path: "/articles/164.pdf",
    preview: "/previews/164.cover.png"
  },
  {
    name: "'Fundraise for the most vulnerable' GoFundMe campaigns fill gaps before government aid kicks in",
    index: "166",
    pdf_path: "/articles/166.pdf",
    preview: "/previews/166.cover.png"
  },
  {
    name: "Gen Z more than doubles its presence in housing market, study finds",
    index: "167",
    pdf_path: "/articles/167.pdf",
    preview: "/previews/167.cover.png"
  },
  {
    name: "Gone in 90 minutes Rental assistance is quickly running out for struggling renters",
    index: "168",
    pdf_path: "/articles/168.pdf",
    preview: "/previews/168.cover.png"
  },
  {
    name: "Government extends moratorium on some foreclosures and evictions through August",
    index: "176",
    pdf_path: "/articles/176.pdf",
    preview: "/previews/176.cover.png"
  },
  {
    name: "Government relieves homeowners_ biggest worry about forbearance amid pandemic",
    index: "177",
    pdf_path: "/articles/177.pdf",
    preview: "/previews/177.cover.png"
  },
  {
    name: "Half of Americans took from retirement savings or plan to amid pandemic, survey finds",
    index: "178",
    pdf_path: "/articles/178.pdf",
    preview: "/previews/178.cover.png"
  },
  {
    name: "Here are the best and worst U.S. states for retirement",
    index: "179",
    pdf_path: "/articles/179.pdf",
    preview: "/previews/179.cover.png"
  },
  {
    name: "Here are the results of the 12 state ballot measures that could affect your personal finances",
    index: "180",
    pdf_path: "/articles/180.pdf",
    preview: "/previews/180.cover.png"
  },
  {
    name: "Here are the risks of using dividend investing in your retirement strategy - Cashay",
    index: "181",
    pdf_path: "/articles/181.pdf",
    preview: "/previews/181.cover.png"
  },
  {
    name: "Here are the world's best places to retire in 2021",
    index: "182",
    pdf_path: "/articles/182.pdf",
    preview: "/previews/182.cover.png"
  },
  {
    name: "Here's how the new stimulus deal could help struggling renters if signed into law",
    index: "183",
    pdf_path: "/articles/183.pdf",
    preview: "/previews/183.cover.png"
  },
  {
    name: "Here's how the retirement landscape for Americans has shifted due to the pandemic_ Money, Honestly podcast - Cashay",
    index: "184",
    pdf_path: "/articles/184.pdf",
    preview: "/previews/184.cover.png"
  },
  {
    name: "Here's how to incorporate Bitcoin into your retirement investments - Cashay",
    index: "185",
    pdf_path: "/articles/185.pdf",
    preview: "/previews/185.cover.png"
  },
  {
    name: "Here's how to negotiate with your landlord if you're facing eviction - Cashay",
    index: "186",
    pdf_path: "/articles/186.pdf",
    preview: "/previews/186.cover.png"
  },
  {
    name: "Here's how to pay back your 401k loan - Cashay",
    index: "187",
    pdf_path: "/articles/187.pdf",
    preview: "/previews/187.cover.png"
  },
  {
    name: "Here's how to plan for retirement around Social Security uncertainty - Cashay",
    index: "188",
    pdf_path: "/articles/188.pdf",
    preview: "/previews/188.cover.png"
  },
  {
    name: "Here's the history of the 30-year fixed mortgage rate - Cashay",
    index: "189",
    pdf_path: "/articles/189.pdf",
    preview: "/previews/189.cover.png"
  },
  {
    name: "Here's what the new coronavirus stimulus deal means for your wallet - Cashay",
    index: "190",
    pdf_path: "/articles/190.pdf",
    preview: "/previews/190.cover.png"
  },
  {
    name: "Here's what to consider before getting into day trading - Cashay",
    index: "191",
    pdf_path: "/articles/191.pdf",
    preview: "/previews/191.cover.png"
  },
  {
    name: "Here's what to do if you plan to buy a house in 2021 - Cashay",
    index: "192",
    pdf_path: "/articles/192.pdf",
    preview: "/previews/192.cover.png"
  },
  {
    name: "Here's what to do if your employer cuts your 401k match - Cashay",
    index: "193",
    pdf_path: "/articles/193.pdf",
    preview: "/previews/193.cover.png"
  },
  {
    name: "Here's what to do if your utilities are shut off - Cashay",
    index: "194",
    pdf_path: "/articles/194.pdf",
    preview: "/previews/194.cover.png"
  },
  {
    name: "Here's what you need to know about flood insurance during hurricane season - Cashay",
    index: "195",
    pdf_path: "/articles/195.pdf",
    preview: "/previews/195.cover.png"
  },
  {
    name: "Here's what you need to know about the new eviction moratorium - Cashay",
    index: "196",
    pdf_path: "/articles/196.pdf",
    preview: "/previews/196.cover.png"
  },
  {
    name: "Here's why utility disconnections are becoming a bigger problem 'Money, Honestly' podcast - Cashay",
    index: "197",
    pdf_path: "/articles/197.pdf",
    preview: "/previews/197.cover.png"
  },
  {
    name: "Homebuyers rush back in droves despite coronavirus pandemic",
    index: "198",
    pdf_path: "/articles/198.pdf",
    preview: "/previews/198.cover.png"
  },
  {
    name: "Home equity hits all time high, but Americans aren't tapping it",
    index: "199",
    pdf_path: "/articles/199.pdf",
    preview: "/previews/199.cover.png"
  },
  {
    name: "Home equity wealth in America is booming",
    index: "200",
    pdf_path: "/articles/200.pdf",
    preview: "/previews/200.cover.png"
  },
  {
    name: "Homeowners now face a new fee when refinancing",
    index: "201",
    pdf_path: "/articles/201.pdf",
    preview: "/previews/201.cover.png"
  },
  {
    name: "Homeowners will face new refinancing fee starting in September",
    index: "202",
    pdf_path: "/articles/202.pdf",
    preview: "/previews/202.cover.png"
  },
  {
    name: "Home sales reach highest levels since the 2006 housing bubble",
    index: "203",
    pdf_path: "/articles/203.pdf",
    preview: "/previews/203.cover.png"
  },
  {
    name: "Housing expert_ 30 million US renters 'at risk of eviction'",
    index: "204",
    pdf_path: "/articles/204.pdf",
    preview: "/previews/204.cover.png"
  },
  {
    name: "Housing expert_ Eviction moratoriums are 'not enough'",
    index: "205",
    pdf_path: "/articles/205.pdf",
    preview: "/previews/205.cover.png"
  },
  {
    name: "Housing expert_ Home sales could fall 30% to 40% in the next months",
    index: "206",
    pdf_path: "/articles/206.pdf",
    preview: "/previews/206.cover.png"
  },
  {
    name: "Housing expert_ 'Urban exodus appears to be real'",
    index: "207",
    pdf_path: "/articles/207.pdf",
    preview: "/previews/207.cover.png"
  },
  {
    name: "Housing trend driven by _sizzle of getting cash now_ has experts worried",
    index: "208",
    pdf_path: "/articles/208.pdf",
    preview: "/previews/208.cover.png"
  },
  {
    name: "How Mike Bloomberg's new retirement plans stack up vs. other Democrats",
    index: "209",
    pdf_path: "/articles/209.pdf",
    preview: "/previews/209.cover.png"
  },
  {
    name: "How Ruth Bader Ginsburg paved the way for equality in personal finances",
    index: "210",
    pdf_path: "/articles/210.pdf",
    preview: "/previews/210.cover.png"
  },
  {
    name: "How simply getting a credit card allowed women to eventually build wealth - Cashay",
    index: "211",
    pdf_path: "/articles/211.pdf",
    preview: "/previews/211.cover.png"
  },
  {
    name: "How the coronavirus stimulus package makes it easier to tap your retirement savings",
    index: "212",
    pdf_path: "/articles/212.pdf",
    preview: "/previews/212.cover.png"
  },
  {
    name: "How to file the FAFSA, the most important financial aid form for college - Cashay",
    index: "213",
    pdf_path: "/articles/213.pdf",
    preview: "/previews/213.cover.png"
  },
  {
    name: "How to get ahead on your retirement savings in 2020",
    index: "214",
    pdf_path: "/articles/214.pdf",
    preview: "/previews/214.cover.png"
  },
  {
    name: "How to protect retirement savings as stocks plunge on coronavirus fears",
    index: "215",
    pdf_path: "/articles/215.pdf",
    preview: "/previews/215.cover.png"
  },
  {
    name: "How to recover after withdrawing early from your retirement savings - Cashay",
    index: "216",
    pdf_path: "/articles/216.pdf",
    preview: "/previews/216.cover.png"
  },
  {
    name: "How to renegotiate a lease with your landlord during the pandemic - Cashay",
    index: "217",
    pdf_path: "/articles/217.pdf",
    preview: "/previews/217.cover.png"
  },
  {
    name: "How to stay on track for early retirement despite the coronavirus pandemic - Cashay",
    index: "218",
    pdf_path: "/articles/218.pdf",
    preview: "/previews/218.cover.png"
  },
  {
    name: "How you should navigate retirement during the pandemic - Cashay",
    index: "219",
    pdf_path: "/articles/219.pdf",
    preview: "/previews/219.cover.png"
  },
  {
    name: "'In fear of my life' Loved ones send money to help protect inmates during pandemic",
    index: "222",
    pdf_path: "/articles/222.pdf",
    preview: "/previews/222.cover.png"
  },
  {
    name: "IRS extends deadline for retirees to undo required distributions",
    index: "224",
    pdf_path: "/articles/224.pdf",
    preview: "/previews/224.cover.png"
  },
  {
    name: "Key Social Security changes you should know about in 2021",
    index: "225",
    pdf_path: "/articles/225.pdf",
    preview: "/previews/225.cover.png"
  },
  {
    name: "Landlords can start the eviction process despite moratorium, government says",
    index: "228",
    pdf_path: "/articles/228.pdf",
    preview: "/previews/228.cover.png"
  },
  {
    name: "Lenders slash credit limits, tighten standards as Americans lose jobs in the pandemic",
    index: "230",
    pdf_path: "/articles/230.pdf",
    preview: "/previews/230.cover.png"
  },
  {
    name: "Lost your job_ Everything you need to know about being unemployed",
    index: "231",
    pdf_path: "/articles/231.pdf",
    preview: "/previews/231.cover.png"
  },
  {
    name: "Majority Of U.S. Adults Under 30 Now Living With Parents, Study Finds - HuffPost",
    index: "232",
    pdf_path: "/articles/232.pdf",
    preview: "/previews/232.cover.png"
  },
  {
    name: "Majority of US adults under 30 now living with parents, study finds",
    index: "233",
    pdf_path: "/articles/233.pdf",
    preview: "/previews/233.cover.png"
  },
  {
    name: "Make saving very easy_ Retirement planning tips for the Biden era",
    index: "234",
    pdf_path: "/articles/234.pdf",
    preview: "/previews/234.cover.png"
  },
  {
    name: "Map Here are the best and worst U.S. states for retirement - Cashay",
    index: "235",
    pdf_path: "/articles/235.pdf",
    preview: "/previews/235.cover.png"
  },
  {
    name: "Map Here are the best and worst U.S. states for retirement in 2020",
    index: "236",
    pdf_path: "/articles/236.pdf",
    preview: "/previews/236.cover.png"
  },
  {
    name: "Map_ Where $100k in retirement savings will last the longest",
    index: "237",
    pdf_path: "/articles/237.pdf",
    preview: "/previews/237.cover.png"
  },
  {
    name: "Medicare open enrollment_ Key changes to know for 2021",
    index: "238",
    pdf_path: "/articles/238.pdf",
    preview: "/previews/238.cover.png"
  },
  {
    name: "Millennials are the most likely to raid retirement savings during pandemic",
    index: "243",
    pdf_path: "/articles/243.pdf",
    preview: "/previews/243.cover.png"
  },
  {
    name: "Millennial wealth is still lagging behind previous generations at the same age",
    index: "244",
    pdf_path: "/articles/244.pdf",
    preview: "/previews/244.cover.png"
  },
  {
    name: "Money conversations you should have with your dad (or mom) at every age - Cashay",
    index: "245",
    pdf_path: "/articles/245.pdf",
    preview: "/previews/245.cover.png"
  },
  {
    name: "Money, Honestly podcast_ How the pandemic could affect the homeownership rate for Black Americans - Cashay",
    index: "246",
    pdf_path: "/articles/246.pdf",
    preview: "/previews/246.cover.png"
  },
  {
    name: "'Money is extremely emotional' Here's how your personality plays a role in personal finances",
    index: "247",
    pdf_path: "/articles/247.pdf",
    preview: "/previews/247.cover.png"
  },
  {
    name: "More homeowners requested mortgage forbearance in May amid pandemic",
    index: "248",
    pdf_path: "/articles/248.pdf",
    preview: "/previews/248.cover.png"
  },
  {
    name: "Mortgage applications drop by biggest amount in 11 years",
    index: "249",
    pdf_path: "/articles/249.pdf",
    preview: "/previews/249.cover.png"
  },
  {
    name: "Mortgage applications for home purchases climb 33% as rates reach a record low",
    index: "250",
    pdf_path: "/articles/250.pdf",
    preview: "/previews/250.cover.png"
  },
  {
    name: "Mortgage applications for home purchases jump to highest level in over 11 years",
    index: "251",
    pdf_path: "/articles/251.pdf",
    preview: "/previews/251.cover.png"
  },
  {
    name: "Mortgage applications for home purchases spike despite pandemic",
    index: "252",
    pdf_path: "/articles/252.pdf",
    preview: "/previews/252.cover.png"
  },
  {
    name: "Mortgage applications jump as refi and home purchases rebound",
    index: "253",
    pdf_path: "/articles/253.pdf",
    preview: "/previews/253.cover.png"
  },
  {
    name: "Mortgage app surge suggests home sales rebound amid pandemic",
    index: "254",
    pdf_path: "/articles/254.pdf",
    preview: "/previews/254.cover.png"
  },
  {
    name: "Mortgage delinquencies moderate after hitting nine-year high in the second quarter",
    index: "255",
    pdf_path: "/articles/255.pdf",
    preview: "/previews/255.cover.png"
  },
  {
    name: "Mortgage delinquency rate hits 21-year high",
    index: "256",
    pdf_path: "/articles/256.pdf",
    preview: "/previews/256.cover.png"
  },
  {
    name: "Mortgage forbearances tick higher as homeowners reactivate payment deferral plans",
    index: "257",
    pdf_path: "/articles/257.pdf",
    preview: "/previews/257.cover.png"
  },
  {
    name: "Mortgage rates carve out another low — but remain out of reach for some homeowners and buyers",
    index: "258",
    pdf_path: "/articles/258.pdf",
    preview: "/previews/258.cover.png"
  },
  {
    name: "Mortgage rates dropped to a new low for the 15th time this year",
    index: "259",
    pdf_path: "/articles/259.pdf",
    preview: "/previews/259.cover.png"
  },
  {
    name: "Mortgage rates fall below 3% for the first time in history",
    index: "260",
    pdf_path: "/articles/260.pdf",
    preview: "/previews/260.cover.png"
  },
  {
    name: "Mortgage rates hit 50-year low, flirt with falling below 3%",
    index: "261",
    pdf_path: "/articles/261.pdf",
    preview: "/previews/261.cover.png"
  },
  {
    name: "Mortgage rates hit all-time low_ Is it time to refinance_ - Cashay",
    index: "262",
    pdf_path: "/articles/262.pdf",
    preview: "/previews/262.cover.png"
  },
  {
    name: "Mortgage rates hit an all-time low amid pandemic",
    index: "263",
    pdf_path: "/articles/263.pdf",
    preview: "/previews/263.cover.png"
  },
  {
    name: "Mortgage rates hit a new low again",
    index: "264",
    pdf_path: "/articles/264.pdf",
    preview: "/previews/264.cover.png"
  },
  {
    name: "Mortgage rates hit another record low as new refinance fee kicks in",
    index: "265",
    pdf_path: "/articles/265.pdf",
    preview: "/previews/265.cover.png"
  },
  {
    name: "Mortgage rates hit another record low this year",
    index: "266",
    pdf_path: "/articles/266.pdf",
    preview: "/previews/266.cover.png"
  },
  {
    name: "Mortgage rates hit new low again, allowing record number of homeowners to refinance",
    index: "267",
    pdf_path: "/articles/267.pdf",
    preview: "/previews/267.cover.png"
  },
  {
    name: "Mortgage rates hit record low to start 2021",
    index: "268",
    pdf_path: "/articles/268.pdf",
    preview: "/previews/268.cover.png"
  },
  {
    name: "Mortgage rates sink to 2.66% — a new low — on Christmas Eve",
    index: "269",
    pdf_path: "/articles/269.pdf",
    preview: "/previews/269.cover.png"
  },
  {
    name: "Mortgage rates sink to another new low",
    index: "270",
    pdf_path: "/articles/270.pdf",
    preview: "/previews/270.cover.png"
  },
  {
    name: "Mortgage rates to home prices_ 8 housing predictions for 2021",
    index: "271",
    pdf_path: "/articles/271.pdf",
    preview: "/previews/271.cover.png"
  },
  {
    name: "Mortgage refinances hit 11-year high as coronavirus fears send rates tumbling",
    index: "272",
    pdf_path: "/articles/272.pdf",
    preview: "/previews/272.cover.png"
  },
  {
    name: "Mortgage refinancing fee now postponed until December",
    index: "273",
    pdf_path: "/articles/273.pdf",
    preview: "/previews/273.cover.png"
  },
  {
    name: "Most Americans didn't tamper with their retirement savings even in pandemic, study finds",
    index: "274",
    pdf_path: "/articles/274.pdf",
    preview: "/previews/274.cover.png"
  },
  {
    name: "Most millennial renters can't afford to buy a home — for several reasons - Cashay",
    index: "275",
    pdf_path: "/articles/275.pdf",
    preview: "/previews/275.cover.png"
  },
  {
    name: "Nearly 1 in 3 homeowners with a mortgage could save $300 a month because of low rates",
    index: "277",
    pdf_path: "/articles/277.pdf",
    preview: "/previews/277.cover.png"
  },
  {
    name: "New home sales hit an almost 13-year high in June",
    index: "280",
    pdf_path: "/articles/280.pdf",
    preview: "/previews/280.cover.png"
  },
  {
    name: "'No reason for them to touch anything'_ The new rules of buying and selling a house in a pandemic - Cashay",
    index: "281",
    pdf_path: "/articles/281.pdf",
    preview: "/previews/281.cover.png"
  },
  {
    name: "'Not a rent holiday' Trump's new eviction action leaves renters on the hook for months of backpay",
    index: "282",
    pdf_path: "/articles/282.pdf",
    preview: "/previews/282.cover.png"
  },
  {
    name: "Number of homes for sale hit all-time low",
    index: "283",
    pdf_path: "/articles/283.pdf",
    preview: "/previews/283.cover.png"
  },
  {
    name: "Pandemic could exacerbate longstanding obstacles to homeownership for Black Americans",
    index: "284",
    pdf_path: "/articles/284.pdf",
    preview: "/previews/284.cover.png"
  },
  {
    name: "Pandemic has been _extremely disruptive_ for retirement plans for some Americans",
    index: "285",
    pdf_path: "/articles/285.pdf",
    preview: "/previews/285.cover.png"
  },
  {
    name: "Personal finance expert on stocks plummeting 'I've lost some money — and that's OK'",
    index: "286",
    pdf_path: "/articles/286.pdf",
    preview: "/previews/286.cover.png"
  },
  {
    name: "President Trump's promises to prevent evictions offers 'false hope,' experts say",
    index: "290",
    pdf_path: "/articles/290.pdf",
    preview: "/previews/290.cover.png"
  },
  {
    name: "Record low mortgage rates_ Should you cash out and refinance_ - Cashay",
    index: "292",
    pdf_path: "/articles/292.pdf",
    preview: "/previews/292.cover.png"
  },
  {
    name: "Rental aid_ Here_s where you can find help in every state - Cashay",
    index: "293",
    pdf_path: "/articles/293.pdf",
    preview: "/previews/293.cover.png"
  },
  {
    name: "Resilience 2020_ 5 ways to make a difference in the world - Cashay",
    index: "294",
    pdf_path: "/articles/294.pdf",
    preview: "/previews/294.cover.png"
  },
  {
    name: "Retirees are faring well financially in the pandemic — it's their children they worry about",
    index: "295",
    pdf_path: "/articles/295.pdf",
    preview: "/previews/295.cover.png"
  },
  {
    name: "Retirement_ Average Boomer_s savings would only last seven years, study finds",
    index: "296",
    pdf_path: "/articles/296.pdf",
    preview: "/previews/296.cover.png"
  },
  {
    name: "Retirement expert breaks down 'one of the mistakes people make'",
    index: "297",
    pdf_path: "/articles/297.pdf",
    preview: "/previews/297.cover.png"
  },
  {
    name: "Retirement expert explains 'what everybody should be doing at a minimum'",
    index: "298",
    pdf_path: "/articles/298.pdf",
    preview: "/previews/298.cover.png"
  },
  {
    name: "Retirement expert_ LGBTQ Americans' 'savings are simply smaller' due to discrimination",
    index: "299",
    pdf_path: "/articles/299.pdf",
    preview: "/previews/299.cover.png"
  },
  {
    name: "Retirement expert_ The '4% rule is no longer a safe withdrawal rate'",
    index: "300",
    pdf_path: "/articles/300.pdf",
    preview: "/previews/300.cover.png"
  },
  {
    name: "Retirement expert_ The 'do-nothing' approach is not great advice right now",
    index: "301",
    pdf_path: "/articles/301.pdf",
    preview: "/previews/301.cover.png"
  },
  {
    name: "Retirement expert_ _The latte factor is complete B.S - Cashay",
    index: "302",
    pdf_path: "/articles/302.pdf",
    preview: "/previews/302.cover.png"
  },
  {
    name: "Retirement expert_ 'The pandemic is a wake up call' for everyone",
    index: "303",
    pdf_path: "/articles/303.pdf",
    preview: "/previews/303.cover.png"
  },
  {
    name: "Retirement planning_ 5 moves you should make in your 20s - Cashay",
    index: "304",
    pdf_path: "/articles/304.pdf",
    preview: "/previews/304.cover.png"
  },
  {
    name: "Retirement savings_ What to do when stocks are in turmoil - Cashay",
    index: "305",
    pdf_path: "/articles/305.pdf",
    preview: "/previews/305.cover.png"
  },
  {
    name: "Sallie Krawcheck details the 'real key' to retirement saving",
    index: "306",
    pdf_path: "/articles/306.pdf",
    preview: "/previews/306.cover.png"
  },
  {
    name: "Should you invest in fractional shares_ - Cashay",
    index: "307",
    pdf_path: "/articles/307.pdf",
    preview: "/previews/307.cover.png"
  },
  {
    name: "Social Security 'insurance' Company offers product to protect against surplus running out",
    index: "308",
    pdf_path: "/articles/308.pdf",
    preview: "/previews/308.cover.png"
  },
  {
    name: "Social Security recipients will get $20 more each month in 2021",
    index: "309",
    pdf_path: "/articles/309.pdf",
    preview: "/previews/309.cover.png"
  },
  {
    name: "Soledad O'Brien_ How to choose resilience over rejection - Cashay",
    index: "310",
    pdf_path: "/articles/310.pdf",
    preview: "/previews/310.cover.png"
  },
  {
    name: "Some American homeowners are making a big retirement mistake, survey finds",
    index: "311",
    pdf_path: "/articles/311.pdf",
    preview: "/previews/311.cover.png"
  },
  {
    name: "States where home prices increased the most and least in 2019",
    index: "314",
    pdf_path: "/articles/314.pdf",
    preview: "/previews/314.cover.png"
  },
  {
    name: "States where rent increased the most in 2019",
    index: "315",
    pdf_path: "/articles/315.pdf",
    preview: "/previews/315.cover.png"
  },
  {
    name: "Stock market highs, booming housing, and millions unemployed A tale of two Americas amid the coronavirus pandemic",
    index: "316",
    pdf_path: "/articles/316.pdf",
    preview: "/previews/316.cover.png"
  },
  {
    name: "Struggling renters put pressure on landlords to sell or tighten tenant screening",
    index: "317",
    pdf_path: "/articles/317.pdf",
    preview: "/previews/317.cover.png"
  },
  {
    name: "Study_ Gen Z homebuyers are expanding their 'footprint' in housing market - Cashay",
    index: "319",
    pdf_path: "/articles/319.pdf",
    preview: "/previews/319.cover.png"
  },
  {
    name: "Suze Orman_ The 60-40 portfolio 'is dead'",
    index: "320",
    pdf_path: "/articles/320.pdf",
    preview: "/previews/320.cover.png"
  },
  {
    name: "Tapping home equity can create a debt cycle for some homeowners",
    index: "321",
    pdf_path: "/articles/321.pdf",
    preview: "/previews/321.cover.png"
  },
  {
    name: "Tax day extension_ What it means for your retirement savings",
    index: "322",
    pdf_path: "/articles/322.pdf",
    preview: "/previews/322.cover.png"
  },
  {
    name: "The number of 401(k) and IRA millionaires reach record high",
    index: "323",
    pdf_path: "/articles/323.pdf",
    preview: "/previews/323.cover.png"
  },
  {
    name: "The number of 401(k) and IRA millionaires rebounded in the second quarter, hit their second-highest level",
    index: "324",
    pdf_path: "/articles/324.pdf",
    preview: "/previews/324.cover.png"
  },
  {
    name: "The tally of 401k millionaires hits new high",
    index: "325",
    pdf_path: "/articles/325.pdf",
    preview: "/previews/325.cover.png"
  },
  {
    name: "This is why you can't get that historically low mortgage rate",
    index: "327",
    pdf_path: "/articles/327.pdf",
    preview: "/previews/327.cover.png"
  },
  {
    name: "This social security strategy could save you $250,000 in retirement",
    index: "329",
    pdf_path: "/articles/329.pdf",
    preview: "/previews/329.cover.png"
  },
  {
    name: "Trump's permanent payroll tax cut would deplete Social Security funds by 2023, analysis finds",
    index: "335",
    pdf_path: "/articles/335.pdf",
    preview: "/previews/335.cover.png"
  },
  {
    name: "Trump stumbles on economic victory lap_ HOW ARE YOUR 409KS DOING",
    index: "336",
    pdf_path: "/articles/336.pdf",
    preview: "/previews/336.cover.png"
  },
  {
    name: "U.S. homeownership rate hits highest level in 12 years — but it could be a fluke",
    index: "338",
    pdf_path: "/articles/338.pdf",
    preview: "/previews/338.cover.png"
  },
  {
    name: "Verizon CEO Hans Vestberg encourages 2020 graduates to 'learn from other cultures' - Cashay",
    index: "339",
    pdf_path: "/articles/339.pdf",
    preview: "/previews/339.cover.png"
  },
  {
    name: "Warren Buffett offers key retirement strategy for Berkshire Hathaway shareholders - Cashay",
    index: "341",
    pdf_path: "/articles/341.pdf",
    preview: "/previews/341.cover.png"
  },
  {
    name: "What are Americans_ top 2020 financial resolutions_ - Cashay",
    index: "343",
    pdf_path: "/articles/343.pdf",
    preview: "/previews/343.cover.png"
  },
  {
    name: "What happens when you drain your 401k retirement savings in your 20s - Cashay",
    index: "344",
    pdf_path: "/articles/344.pdf",
    preview: "/previews/344.cover.png"
  },
  {
    name: "What should you do with your 401k after the election_ - Cashay",
    index: "345",
    pdf_path: "/articles/345.pdf",
    preview: "/previews/345.cover.png"
  },
  {
    name: "What you don't know about your parents retirement plans could hurt you financially",
    index: "346",
    pdf_path: "/articles/346.pdf",
    preview: "/previews/346.cover.png"
  },
  {
    name: "What you should know about home renovations — both professional and DIY ones - Cashay",
    index: "347",
    pdf_path: "/articles/347.pdf",
    preview: "/previews/347.cover.png"
  },
  {
    name: "Where the remaining 2020 candidates stand on retirement",
    index: "348",
    pdf_path: "/articles/348.pdf",
    preview: "/previews/348.cover.png"
  },
  {
    name: "Where your retirement savings will last the longest - Cashay",
    index: "349",
    pdf_path: "/articles/349.pdf",
    preview: "/previews/349.cover.png"
  },
  {
    name: "Why early retirement may not be worth it after all - Cashay",
    index: "350",
    pdf_path: "/articles/350.pdf",
    preview: "/previews/350.cover.png"
  }
];

export const frontPageArticles = [
    {
      "name": "Biden's executive action to extend eviction moratorium is a 'Band-Aid' on the rental crisis",
      "pdf_path": "/frontpage/Biden's executive action to extend eviction moratorium is a 'Band-Aid' on the rental crisis.pdf",
      "preview": "/frontpage/Biden's executive action to extend eviction moratorium is a 'Band-Aid' on the rental crisis.cover.png"
    },
    {
      "name": "Budget breakdown_ How three millennials spend and save their $50,000 salary - Cashay",
      "pdf_path": "/frontpage/Budget breakdown_ How three millennials spend and save their $50,000 salary - Cashay.pdf",
      "preview": "/frontpage/Budget breakdown_ How three millennials spend and save their $50,000 salary - Cashay.cover.png"
    },
    {
      "name": "Early retirement_ What happens when the unexpected occurs (1)",
      "pdf_path": "/frontpage/Early retirement_ What happens when the unexpected occurs (1).pdf",
      "preview": "/frontpage/Early retirement_ What happens when the unexpected occurs (1).cover.png"
    },
    {
      "name": "Gone in 90 minutes Rental assistance is quickly running out for struggling renters",
      "pdf_path": "/frontpage/Gone in 90 minutes Rental assistance is quickly running out for struggling renters.pdf",
      "preview": "/frontpage/Gone in 90 minutes Rental assistance is quickly running out for struggling renters.cover.png"
    },
    {
      "name": "'In fear of my life' Loved ones send money to help protect inmates during pandemic",
      "pdf_path": "/frontpage/'In fear of my life' Loved ones send money to help protect inmates during pandemic.pdf",
      "preview": "/frontpage/'In fear of my life' Loved ones send money to help protect inmates during pandemic.cover.png"
    }
]